// extracted by mini-css-extract-plugin
export default {"container":"mosaicoEditor_container__wMBZ5"};